import React, { useEffect, useRef } from 'react';

const ViewerInput = (props) => {
    const { className, name, value, placeholder, onChange, onBlur, onFocus,
        labelText, hasError, errorMsg, showErrorMsg, autoFocus } = props;
    const inputRef = useRef();

    const handleInputChange = (e) => {
        const newValue = e.target && e.target.value;
        onChange(name, newValue);
    };

    const handleInputBlur = () => {
        onBlur(name, value);
    };

    useEffect(() => {
        if (autoFocus && inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    const isErrorInput = hasError && hasError({ name, value });
    const showError = showErrorMsg ? showErrorMsg({ name, value }) : !isErrorInput;
    return (<div className={`${className} seismic-engagement-viewer-input-container ${showError ? 'with-error' : ''}`}>
        {labelText && <label htmlFor={name} className={`input-label ${value && value.length ? 'has-value' : ''}`}>
            {labelText}
        </label>}
        <input
            ref={inputRef}
            name={name}
            className={`input-box ${!isErrorInput ? 'invalid-input' : 'valid-input'}`}
            onBlur={handleInputBlur}
            onFocus={onFocus}
            value={value}
            placeholder={placeholder}
            onChange={handleInputChange} />
        { showError && errorMsg && <span className="input-error-message">{errorMsg}</span>}
    </div>);
};

export default ViewerInput;
